/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { injectable } from 'inversify';
import { PendingPaymentPageAgent, getAgent } from './agent';
import { logger as log } from '../../../common/logger';
const is = require('is_js');

const SERVICE_NAME = 'PendingPaymentPageService';

@injectable()
export class PendingPaymentPageService {
  private static instance: PendingPaymentPageService;
  public agent: PendingPaymentPageAgent;
  static displayName = 'PendingPaymentPageService';

  constructor(props: any = {}) {
    this.agent = getAgent();
  }
}
